export class Breadcrumb {
  label: string;
  url: string;
  deep: number;

  constructor(label: string, url?: string, deep?: number) {
    this.label = label;
    this.url = url;
    this.deep = deep;
  }
}
